export enum ModalSize {
    sm = "modal-sm",
    md = "",
    lg = "modal-lg",
    xl = "modal-xl"
}
